/* eslint-disable unicorn/prefer-spread */
import {
    AfterViewInit,
    Component,
    Input,
    ViewChild,
    ElementRef,
    ChangeDetectionStrategy,
} from "@angular/core";

import { GridFacade } from "@hermes/states/grid-filters-state";

@Component({
    selector: "h-grid-seo-text",
    templateUrl: "./grid-seo-text.component.html",
    styleUrls: ["./grid-seo-text.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridSeoTextComponent implements AfterViewInit {
    @Input()
    public text?: string;

    @ViewChild("textRef")
    public textHtml!: ElementRef<HTMLDivElement>;
    public expanded: boolean = false;
    public arrayLinksVisibility: boolean[] = [];
    constructor(public gridFacade: GridFacade) {}

    public ngAfterViewInit(): void {
        this.createArrayOfVisibleLinks();
        this.makeInvisibleLinksInaccessible();
    }

    public toggleExpanded(): void {
        this.expanded = !this.expanded;
        if (this.expanded) {
            this.makeAllLinksAccessible();
        } else {
            this.makeInvisibleLinksInaccessible();
        }
    }

    /**
     * Create array of boolean that show if link is visible or not.
     */
    private createArrayOfVisibleLinks(): void {
        this.arrayLinksVisibility = Array.from(
            this.textHtml.nativeElement.querySelectorAll("a"),
        ).map((link) => this.isVisible(link, this.textHtml.nativeElement));
    }

    /**
     * Set tabindex -1 to links to be not focusable by tabulation when the text is not expanded.
     */
    private makeInvisibleLinksInaccessible(): void {
        Array.from(this.textHtml.nativeElement.querySelectorAll("a")).forEach(
            (link, index) => {
                link.setAttribute(
                    "tabindex",
                    this.arrayLinksVisibility[index] ? "0" : "-1",
                );
            },
        );
    }

    /**
     * Focus SEO text and set tabindex 0 to all links when text is expanded.
     */
    private makeAllLinksAccessible(): void {
        this.textHtml.nativeElement.focus();
        Array.from(this.textHtml.nativeElement.querySelectorAll("a")).forEach(
            (link) => link.setAttribute("tabindex", "0"),
        );
    }

    /**
     * Return a boolean, this function check if element is visible or not.
     */
    private isVisible(element: HTMLElement, container: HTMLElement): boolean {
        const eleTop = element.offsetTop;
        const eleBottom = eleTop + element.clientHeight;

        const containerTop = container.scrollTop;
        const containerBottom = containerTop + container.clientHeight;

        // The element is fully visible in the container
        return (
            (eleTop >= containerTop && eleBottom <= containerBottom) ||
            // Some part of the element is visible in the container
            (eleTop < containerTop && containerTop < eleBottom) ||
            (eleTop < containerBottom && containerBottom < eleBottom)
        );
    }
}
